
var inputNumberAndLetter = (rule, value, callback) => {
  var zg = /^[0-9]*[1-9][0-9]*$/;
  if (!zg.test(value)) {
    callback(new Error('请输入正整数'));
  }else if(Number(value)>999999||Number(value)<1){
    callback(new Error('请输入1-999999数字'));
  } else {
    callback();
  }
};
export default {
  submitText: '保存',
  emptyBtn: false,
  column: [
    {
      label: '上级节点',
      prop: 'parentId',
      formslot: true,
      rules: [
        {
          // required: true,
          message: '请选择上级节点',
          trigger: 'blur',
        },
      ],
      span: 12,
    },
    {
      label: '上级属性',
      prop: 'parentObjectTypeName',
      readonly: true,
      span: 12,
    },
    {
      label: '本级属性',
      prop: 'objectType',
      type: 'select',
      dataType: 'number',
      dicUrl: 'api/blade-system/dict/dictionary?code=object_type',
      props: { label: 'dictValue', value: 'dictKey' },
      rules: [{ required: true, message: '请输入本级属性', trigger: 'change' }],
      span: 12,
    },
    {
      label: '顺序号',
      prop: 'indexNum',
      type: 'number',
      rules: [
        { required: true, message: '请输入顺序号', trigger: 'blur' },
        
        {
          validator: inputNumberAndLetter,
          trigger: 'blur',
        },
        // { pattern: /^[0-9]*[1-9][0-9]*$/, message: '请输入正整数', trigger: 'blur'  },
        // { min: 1, max: 999999, message: '顺序号超长', trigger: 'blur'  },
      ],
      span: 12,
    },
    /*{
      label: '属性编码',
      prop: 'objectCode',
      rules: [
        {
          required: true,
          message: '请输入属性编码',
          trigger: 'blur',
        },
      ],
      span: 12,
    },*/
    {
      label: '房屋性质',
      prop: 'useType',
      type: 'select',
      dataType: 'number',
      dicUrl: 'api/base/property/getUseTypes?code=use_type&remark=0',
      props: { label: 'dictValue', value: 'dictKey' },
      rules: [
        {
          required: false,
          message: '请选择房屋性质',
          trigger: 'blur',
        },
      ],
      span: 8,
    },
    {
      label: '属性名称',
      prop: 'objectName',
      rules: [
        {
          required: true,
          message: '请输入属性名称',
          trigger: 'blur',
        },
      ],
      span: 12,
    },
    {
      label: '建筑面积',
      prop: 'floorage',
      placeholder: '请输入 建筑面积，单位m2',
      rules: [
        {
          pattern: /(^0$)|(^[1-9](\d{0,9})?(\.\d{0,2})?$)|(^[0-9]$)|(^\d\.[0-9]{1,2}$)|(^\d\.[0]{1}[1-9]{1}$|(^\d\.[1-9]{1}[0]{1}$)$)/,
          message: '请输入整数10位，小数2位',
        },
      ],
      span: 12,
    },
    {
      label: '使用面积',
      prop: 'usableArea',
      placeholder: '请输入 使用面积，单位m2',
      rules: [
        {
          pattern: /(^0$)|(^[1-9](\d{0,9})?(\.\d{0,2})?$)|(^[0-9]$)|(^\d\.[0-9]{1,2}$)|(^\d\.[0]{1}[1-9]{1}$|(^\d\.[1-9]{1}[0]{1}$)$)/,
          message: '请输入整数10位，小数2位',
        },
      ],
      span: 12,
    },
    {
      label: '门数量',
      prop: 'doorsNum',
      placeholder: '请输入 门数量',
      rules: [{ pattern: /^[0-9]*[1-9][0-9]*$/, message: '请输入正整数' }],
      span: 12,
    },
    {
      label: '小区分组',
      prop: 'communityGroup',
      type: 'select',
      dataType: 'string',
      dicUrl: 'api/blade-system/dict-biz/dictionary?code=community_group',
      props: { label: 'dictValue', value: 'dictKey' },
      // rules: [{ required: true, message: '请输入小区分组', trigger: 'change' }],
      span: 12,
    },
    {
      label: '用途',
      prop: 'useDesc',
      maxlength: 50,
      span: 12,
    },
    {
      label: '环境描述',
      prop: 'envDesc',
      span: 24,
      maxlength: 300,
    },
    {
      label: '总面积',
      prop: 'totalArea',
      display: false,
      rules: [
        {
          required: true,
          pattern: /(^0$)|(^[1-9](\d{0,9})?(\.\d{0,2})?$)|(^[0-9]$)|(^\d\.[0-9]{1,2}$)|(^\d\.[0]{1}[1-9]{1}$|(^\d\.[1-9]{1}[0]{1}$)$)/,
          message: '请输入整数10位，小数2位',
        },
      ],
      placeholder: '请输入 总面积，单位m2',
      span: 8,
    },
    {
      label: '已用面积',
      prop: 'usedArea',
      display: false,
      rules: [
        {
          required: true,
          pattern: /(^0$)|(^[1-9](\d{0,9})?(\.\d{0,2})?$)|(^[0-9]$)|(^\d\.[0-9]{1,2}$)|(^\d\.[0]{1}[1-9]{1}$|(^\d\.[1-9]{1}[0]{1}$)$)/,
          message: '请输入整数10位，小数2位',
        },
      ],
      placeholder: '请输入 已用面积，单位m2',
      span: 8,
    },
    {
      label: '可用面积',
      prop: 'availableArea',
      display: false,
      rules: [
        {
          required: true,
          pattern: /(^0$)|(^[1-9](\d{0,9})?(\.\d{0,2})?$)|(^[0-9]$)|(^\d\.[0-9]{1,2}$)|(^\d\.[0]{1}[1-9]{1}$|(^\d\.[1-9]{1}[0]{1}$)$)/,
          message: '请输入整数10位，小数2位',
        },
      ],
      placeholder: '请输入 可用面积，单位m2',
      span: 8,
    },
  ],
};
